import styled, { useTheme } from 'styled-components';

import { min } from '../utils/breakpoints';

const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-top: 24px;
  margin-bottom: 20px;
  padding: 20px;
  width: 100%;
  border-radius: 4px;
  text-align: left;
  border: 1px solid ${(props) => props.theme.colors.primary};
`;

const Message = styled.p`
  font-size: 14px;
  color: ${(props) => props.theme.colors.dark};
  margin-bottom: 8px;
  font-weight: bold;

  ${min.sm} {
    font-size: 16px;
  }
`;

const Icon = styled.img`
  position: relative;
  top: -2px;
  margin-right: 8px;
`;

const SubMessage = styled.p`
  font-size: 14px;
  color: ${(props) => props.theme.colors.dark};
  margin-bottom: 0;
  ${min.sm} {x
    font-size: 16px;
  }
`;

const StyledLink = styled.a`
  margin-top: 8px;
  font-size: 14px;

  ${min.sm} {
    font-size: 16px;
  }
`;

const StyledButton = styled.button`
  margin-top: 8px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  outline: inherit;
  text-decoration: underline !important;
  color: ${(props) => props.theme.colors.primary};
  display: inline-block;
  font-size: 14px;

  ${min.sm} {
    font-size: 16px;
  }
`;

interface WarningPanelProps {
  title?: string;
  body?: string;
  linkText?: string;
  linkUrl?: string;
  linkAction?: () => void;
  children?: React.ReactNode;
  styleOverride?: React.CSSProperties;
}

const WarningPanel = ({
  title = '',
  body = '',
  linkText = '',
  linkUrl,
  linkAction,
  children,
  styleOverride,
}: WarningPanelProps) => {
  const theme = useTheme();

  return (
    <EmptyStateContainer style={styleOverride}>
      <>
        <Message>
          <Icon src={theme.icons.info} alt="Info" />
          {title}
        </Message>
        <SubMessage>{body}</SubMessage>
        {linkText && linkUrl && <StyledLink href={linkUrl}>{linkText}</StyledLink>}
        {linkAction && linkText && !linkUrl && <StyledButton onClick={linkAction}>{linkText}</StyledButton>}
        {children}
      </>
    </EmptyStateContainer>
  );
};

export default WarningPanel;
